import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ProjetosComponent } from './projetos/projetos.component';
import { ProjetoComponent } from './projeto/projeto.component';
import { NitComponent } from './nit/nit.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { InovacaoTecnologiaComponent } from './inovacao-tecnologia/inovacao-tecnologia.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { ParceriasComponent } from './parcerias/parcerias.component';
import { AmbientesInovacaoComponent } from './ambientes-inovacao/ambientes-inovacao.component';
import { EmpreendedorismoComponent } from './empreendedorismo/empreendedorismo.component';
import { VitrineComponent } from './vitrine/vitrine.component';
import { HomeComponent } from './home/home.component';
import { HttpClientModule }    from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    ProjetosComponent,
    ProjetoComponent,
    NitComponent,
    PageNotFoundComponent,
    InovacaoTecnologiaComponent,
    NoticiasComponent,
    ParceriasComponent,
    AmbientesInovacaoComponent,
    EmpreendedorismoComponent,
    VitrineComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
